// Ionic & Angular Imports
import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Observable} from 'rxjs/observable';
import 'rxjs/add/operator/map';

// Interfaces
export interface Company {
    id: number;
    name: string;
}

@Injectable()
export class rsCompanySvc {

    constructor( private http: Http ) 
    {
        
    }
    getCompanies( filter: string = "visible" ) : Observable<Company[]> {
        // Return our observable
        return Observable.create( observer => {
            // This method gets run when an object subscribes
            this.http.get( 'http://dfr.hydrocon.com/api/v1/subcontractors/filters/' + filter, {
                withCredentials: true
            })
            .map( res => {
                return res.json().response.subcontractors;
            })
            .subscribe( result => {
                // operation successful
                observer.next(result);
            }, err=> {
                // error encountered
                observer.error(err);
            }, () => {
                // operation complete
                observer.complete();
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/company.service.ts